import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { format } from "date-fns";
import { useEffect, useRef, useState } from "react";
import { JVDate } from "../../shared/JVDate";
import { Button } from "primereact/button";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Fetch } from "../../shared/Fetch";
import { IFrequencyTable } from "./FrequencyTable";
import { JVTime } from "../../shared/JVTime";
import { MultiSelect } from "primereact/multiselect";
import { IRolesDropdown } from "../../models/IDropdown";
import { JVMultiselect } from "../../shared/JVMultiselect";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVInput } from "../../shared/JVInput";
import { Card } from "primereact/card";

interface IProps {
    open: boolean,
    singleData: IFrequencyTable,
    hideDialog: () => void,
    toast: any
}

interface IAcknowledgeEmailSelectTableEmails {
    timesheet_Acknowledge_Setting_ID?: number,
    role_ID_CC?: string[],
    role_ID_BCC?: string[],
    email_CC?: string[],
    email_BCC?: string[],
}

interface IAcknowledgeEmailSelectTableForm {
    email_CC?: string | null,
    email_BCC?: string | null,
}

const schema = yup.object({
    email_CC: yup.string().nullable(),
    email_BCC: yup.string().nullable(),
});

export const AcknowledgeEmailSelectTable = (props: IProps) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [roles, setRoles] = useState<Array<IRolesDropdown>>();
    const [selectedRoles, setSelectedRoles] = useState<Array<IRolesDropdown>>();
    const [selectedRoles2, setSelectedRoles2] = useState<Array<IRolesDropdown>>();
    const [toCCEmails, setToCCEmails] = useState<Array<string>>([]);
    const [toBCCEmails, setToBCCEmails] = useState<Array<string>>([]);
    const [tableData, setTableData] = useState<IAcknowledgeEmailSelectTableEmails>({});
    const dt = useRef<any>(null);

    const { control, handleSubmit, formState: { errors }, reset, setValue, watch } = useForm<IAcknowledgeEmailSelectTableForm>({
        resolver: yupResolver(schema),
        defaultValues: {},
        shouldFocusError: false
    });

    const emailBCC = useForm<IAcknowledgeEmailSelectTableForm>({
        resolver: yupResolver(schema),
        defaultValues: {},
        shouldFocusError: false
    });

    const onHide = () => {
        setToCCEmails([]);
        setToBCCEmails([]);
        reset({ email_CC: null, email_BCC: null, });
        emailBCC.reset({ email_CC: null, email_BCC: null, });
        setSelectedRoles([]);
        setSelectedRoles2([]);
        setTableData({});
        setLoading(false);
        props.hideDialog();
    }

    const updatedOn = (rowData: any) => {
        let date;
        if (rowData.updated_On) date = format(new Date(rowData.updated_On), 'dd/MM/yyyy HH:mm a').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const loadRoles = async () => {
        const response = await Fetch("Timesheet/roles", "GET", null, null, null);
        if (response) {
            const data: Array<IRolesDropdown> = await response.json();
            const _data: Array<IRolesDropdown> = [];
            data.forEach(d => {
                _data.push({ role_ID: d.role_ID, role_Name: d.role_Name });
            })
            setRoles(_data);
        }
    }

    const header = () => {
        return <p></p>;
    }

    const onSubmit = async (data: any) => {
        setLoading(true);

        const newBody: any = {
            id: 1,
            timesheet_Acknowledge_Setting_ID: props.singleData.id,
            role_ID_CC: (selectedRoles || []).map(el => (el.role_ID || "")).join(", "),
            email_CC: (data.email_CC || "").split(",").map((el: string) => el.trim()).join(", ")
        };

        const response = await Fetch(`Timesheet/updateSendEmailAcknowledgeCC`, "PUT", newBody, null, props.toast);
        if (response) {
            setLoading(false);
            reset({ email_CC: "", email_BCC: "" });
            emailBCC.reset({ email_CC: "", email_BCC: "" });
            setSelectedRoles([]);
            setSelectedRoles2([]);
            loadTableData();
        } else setLoading(false);
    }

    const removeEmailCC = async (el: string, index: number) => {
        let newBody: any = {
            id: 1,
            timesheet_Acknowledge_Setting_ID: props.singleData.id,
            //role_ID_CC: tableData.role_ID_CC,
            email_CC: tableData.email_CC
        };

        let quryParam: string = "";

        if (tableData.email_CC?.includes(el)) {
            newBody.email_CC = tableData.email_CC.filter(ele => ele !== el).join(", ");
        } else if (tableData.role_ID_CC?.includes(el)) {
            quryParam = quryParam + `roleName=${el}`;
        }

        setLoading(true);

        const response = await Fetch(`Timesheet/updateSendEmailAcknowledgeCCRemove`, "PUT", newBody, quryParam, props.toast);
        if (response) {
            const datas: any = response.json();
            setLoading(false);
            reset({ email_CC: "", email_BCC: "" });
            emailBCC.reset({ email_CC: "", email_BCC: "" });
            setSelectedRoles([]);
            setSelectedRoles2([]);
            loadTableData();
            props.toast.current?.show({ severity: 'success', detail: "Updated Successfully", life: 3000 });
        } else setLoading(false);
    }



    const onSubmit2 = async (data: any) => {
        setLoading(true);

        const newBody: any = {
            id: 1,
            timesheet_Acknowledge_Setting_ID: props.singleData.id,
            role_ID_BCC: (selectedRoles || []).map(el => (el.role_ID || "")).join(", "),
            email_BCC: (data.email_BCC || "").split(",").map((el: string) => el.trim()).join(", ")
        };

        const response = await Fetch(`Timesheet/updateSendEmailAcknowledgeBCC`, "PUT", newBody, null, props.toast);
        if (response) {
            setLoading(false);
            reset({ email_CC: "", email_BCC: "" });
            emailBCC.reset({ email_CC: "", email_BCC: "" });
            setSelectedRoles([]);
            setSelectedRoles2([]);
            loadTableData();
        } else setLoading(false);
    }

    const removeEmailBCC = async (el: string, index: number) => {
        let newBody: any = {
            id: 1,
            timesheet_Acknowledge_Setting_ID: props.singleData.id,
            //role_ID_BCC: tableData.role_ID_BCC,
            email_BCC: tableData.email_BCC
        };

        let quryParam: string = "";

        if (tableData.email_BCC?.includes(el)) {
            newBody.email_BCC = tableData.email_BCC.filter(ele => ele !== el).join(", ");
        } else if (tableData.role_ID_BCC?.includes(el)) {
            quryParam = quryParam + `roleName=${el}`;
        }

        setLoading(true);

        const response = await Fetch(`Timesheet/updateSendEmailAcknowledgeBCCRemove`, "PUT", newBody, quryParam, props.toast);
        if (response) {
            const datas: any = response.json();
            setLoading(false);
            reset({ email_CC: "", email_BCC: "" });
            emailBCC.reset({ email_CC: "", email_BCC: "" });
            setSelectedRoles([]);
            setSelectedRoles2([]);
            loadTableData();
            props.toast.current.show({ severity: 'success', detail: "Updated Successfully", life: 3000 });
        } else setLoading(false);
    }



    const loadTableData = async () => {
        setLoading(true);
        const response = await Fetch("Timesheet/getSendEmailAcknowledgeEmails", "GET", null, `id=${props.singleData.id}`, null);
        if (response) {
            const data: IAcknowledgeEmailSelectTableEmails = await response.json() || [];
            let toCC: string[] = data.role_ID_CC || [];
            let toCC2: string[] = data.email_CC || [];
            setToCCEmails([...toCC, ...toCC2]);
            let toBCC: string[] = data.role_ID_BCC || [];
            let toBCC2: string[] = data.email_BCC || [];
            setToBCCEmails([...toBCC, ...toBCC2]);

            setTableData(data);
            setLoading(false);
        } else setLoading(false);
    }

    useEffect(() => {
        if (props.open && props.singleData.id) {
            loadTableData();
            loadRoles();
        }
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Frequency Time" modal className="p-fluid" onHide={onHide}>
            <h5>CC Emails</h5>
            <Card>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                    <JVMultiselect label="To Roles" options={roles} optionLabel="role_Name" placeholder="Select Roles" required value={selectedRoles} onChange={setSelectedRoles} />
                    <JVInput column={3} label="Add CC Emails" control={control} name="email_CC" error={errors.email_CC?.message} />
                    <Button className="w-2 mt-5" style={{ height: "2.5rem" }} label="SAVE" type="submit" loading={loading}></Button>
                </form>
                <div className="mt-2"></div>
                {loading === true ? <div style={{ width: "100%", border: "1px solid #ced4da", height: "15vh", overflowY: "scroll" }} className="flex flex-wrap gap-3 p-2">Loading...</div> : <div style={{ width: "100%", border: "1px solid #ced4da", height: "15vh", overflowY: "scroll" }} className="flex flex-wrap gap-3 p-2">
                    {toCCEmails.map((el: string, index: number) => <div key={index} style={{ maxHeight: "2rem" }} className="border-1 border-400 border-round-sm w-auto p-1">{el}<span className="ml-2 pi pi-times-circle cursor-pointer" onClick={() => removeEmailCC(el, index)}></span></div>)}
                </div>}
            </Card>
            <hr />
            <h5>BCC Emails</h5>
            <Card>
                <form onSubmit={emailBCC.handleSubmit(onSubmit2)} className="p-fluid formgrid grid">
                    <JVMultiselect label="To Roles" options={roles} optionLabel="role_Name" placeholder="Select Roles" required value={selectedRoles2} onChange={setSelectedRoles2} />
                    <JVInput column={3} label="Add BCC Emails" control={emailBCC.control} name="email_CC" error={emailBCC.formState.errors.email_BCC?.message} />
                    <Button className="w-2 mt-5" style={{ height: "2.5rem" }} label="SAVE" type="submit" loading={loading}></Button>
                </form>
                <div className="mt-2"></div>
                {loading === true ? <div style={{ width: "100%", border: "1px solid #ced4da", height: "15vh", overflowY: "scroll" }} className="flex flex-wrap gap-3 p-2">Loading...</div> : <div style={{ width: "100%", border: "1px solid #ced4da", height: "15vh", overflowY: "scroll" }} className="flex flex-wrap gap-3 p-2">
                    {toBCCEmails.map((el: string, index: number) => <div key={index} style={{ maxHeight: "2rem" }} className="border-1 border-400 border-round-sm w-auto p-1">{el}<span className="ml-2 pi pi-times-circle cursor-pointer" onClick={() => removeEmailBCC(el, index)}></span></div>)}
                </div>}
            </Card>
        </Dialog>
    );
}